"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../helpers");
function localStorageUtility() {
    const Window = (0, helpers_1.isClientSide)()
        ? window
        : {
            localStorage: {
                getItem: (k) => null,
                setItem: (k, val) => null,
                removeItem: (key) => null,
            },
        };
    const setItem = (key, value) => {
        return Window.localStorage.setItem(key, JSON.stringify(value));
    };
    const getItem = (key) => {
        const val = Window.localStorage.getItem(key);
        return val ? JSON.parse(val) : null;
    };
    const removeItem = (key) => {
        Window.localStorage.removeItem(key);
    };
    return { setItem, getItem, removeItem };
}
exports.default = localStorageUtility;
